(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mim-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const link = event.target.closest('.mim-page a[href^="#mim-"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  });
  function initializeMimVideo(scope) {
    scope.querySelectorAll('[data-mim-video]').forEach(frame => {
      if (frame.dataset.initialized) return;
      frame.dataset.initialized = 'true';
      const video = frame.querySelector('video');
      const embed = frame.querySelector('iframe');
      if (!video && !embed) return;
      const query = window.matchMedia('(max-width:749px)');
      const dialog = document.createElement('dialog');
      dialog.className = 'mim-video-dialog mim-video-dialog--' + frame.dataset.mimOrientation;
      dialog.setAttribute('aria-label', video?.getAttribute('aria-label') || embed?.title || frame.dataset.playLabel);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'mim-video-dialog__close';
      close.setAttribute('aria-label', frame.dataset.closeLabel);
      close.textContent = '×';
      const player = document.createElement('div');
      player.className = 'mim-video-dialog__player';
      const media = video || embed;
      const embedSource = embed?.getAttribute('src');
      if (embed) embed.removeAttribute('src');
      player.append(media);
      dialog.append(close, player);
      frame.parentElement.append(dialog);
      const overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'mim-popup-cover';
      overlay.setAttribute('aria-label', frame.dataset.playLabel);
      overlay.setAttribute('aria-haspopup', 'dialog');
      const image = document.createElement('img');
      image.alt = '';
      image.width = 1600;
      image.height = Math.round(1600 / (parseFloat(frame.style.getPropertyValue('--mim-cover-ratio')) || 0.5625));
      const play = document.createElement('span');
      play.className = 'mim-video-cover__play';
      play.textContent = '▷';
      play.setAttribute('aria-hidden', 'true');
      const updatePoster = () => {
        const poster = query.matches ? frame.dataset.mobilePoster : frame.dataset.poster;
        if (poster) image.src = poster;
        image.hidden = !poster;
      };
      overlay.append(image, play);
      frame.classList.add('mim-video--popup');
      frame.append(overlay);
      let previousOverflow;
      overlay.addEventListener('click', () => {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        if (video) video.play().catch(() => {});
        if (embed) embed.src = embedSource + (embedSource.includes('?') ? '&' : '?') + 'autoplay=1';
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (video) video.pause();
        if (embed) embed.removeAttribute('src');
        document.body.style.overflow = previousOverflow || '';
      });
      updatePoster();
      query.addEventListener('change', updatePoster);
      const section = frame.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', () => {
        if (dialog.open) dialog.close();
        query.removeEventListener('change', updatePoster);
      }, { once: true });
    });
  }
  initializeMimVideo(document);
  document.addEventListener('shopify:section:load', event => initializeMimVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mim-membership"] && !Shopify.designMode) return;
  try {
    
  function initializeMimWaitlist(scope) {
    scope.querySelectorAll('.mim-waitlist__form').forEach(root => {
      if (root.dataset.spacingInitialized) return;
      root.dataset.spacingInitialized = 'true';
      const compact = () => root.querySelectorAll('.klaviyo-form-richtext p').forEach(paragraph => {
        const hasText = paragraph.textContent.replace(/[\s\u200B-\u200D\uFEFF]/g, '').length > 0;
        if (!hasText && !paragraph.querySelector('img,video,iframe,input,button,a')) paragraph.hidden = true;
      });
      compact();
      new MutationObserver(compact).observe(root, { childList: true, subtree: true });
    });
  }
  initializeMimWaitlist(document);
  document.addEventListener('shopify:section:load', event => initializeMimWaitlist(event.target));

  } catch(e) { console.error(e); }
})();
})();
